// extracted by mini-css-extract-plugin
export var container = "SlideInMenu-module--container--bee5e";
export var hamburgerMenuButton = "SlideInMenu-module--hamburgerMenuButton--30a47";
export var languageSwitcher = "SlideInMenu-module--languageSwitcher--b39dc";
export var languageSwitcherAltLanguage = "SlideInMenu-module--languageSwitcherAltLanguage--d22b7";
export var languageSwitcherCurrentLanguage = "SlideInMenu-module--languageSwitcherCurrentLanguage--ff007";
export var wrapper = "SlideInMenu-module--wrapper--33dba";
export var wrapperOpen = "SlideInMenu-module--wrapperOpen--50a93";